import React, { useState } from 'react';
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, TableSortLabel } from '@mui/material';
import styled from '@emotion/styled';

const StyledTable = styled(Table)`
    border-collapse: collapse;
`;

const StyledTableRow = styled(TableRow)`
    border-bottom: none;
`;

const StyledTableCell = styled(TableCell)`
  border-bottom: none;
  padding: 5px;
`;

const DetailLabel = styled(StyledTableCell)`
width: 25%;
  font-weight: bold;
  text-align: right;
`;

function GenericDetailsTable({ detailsList, detailsValue }) {
    return (
            <StyledTable>
                 <TableBody>
                    {detailsList.map((detailConfig) => {
                        return (
                            <StyledTableRow key={detailConfig.key}>
                                <DetailLabel>{detailConfig.label}</DetailLabel>
                                <StyledTableCell align="left">
                                    {detailConfig.render ? detailConfig.render(detailsValue) : detailsValue[detailConfig.key]}
                                </StyledTableCell>
                            </StyledTableRow>
                        );
                    })}
                </TableBody>
                {/* <TableBody>
                    {detailsValue && Object.entries(detailsValue)
                        .filter(([detail]) => detailsList.some(d => d.key === detail))
                        .map(([detail, value]) => {
                            const detailConfig = detailsList.find(d => d.key === detail);
                            return (
                                <StyledTableRow key={detail}>
                                    <DetailLabel>{detailConfig.label}</DetailLabel>
                                    <StyledTableCell align="left">{detailConfig.render ? detailConfig.render(value) : value}</StyledTableCell>
                                </StyledTableRow>
                            );
                        })}
                </TableBody> */}
            </StyledTable>
    );
}

export default GenericDetailsTable;
